import { FC, createContext, useContext } from "react";

import {
  DEFAULT_RADAR,
  RADARS,
  RadarDescriptor,
  RadarSlug,
} from "../../radars";

export interface RadarContextValue {
  slug: RadarSlug;
  descriptor: RadarDescriptor;
}

const defaultValue: RadarContextValue = {
  slug: DEFAULT_RADAR,
  descriptor: RADARS[DEFAULT_RADAR],
};

/**
 * `Link` needs to know which radar it lives in to prefix every internal URL,
 * and it is rendered far below the router. A context is the only way to reach
 * it without threading a prop through every component.
 */
const RadarContext = createContext<RadarContextValue>(defaultValue);

export const RadarProvider: FC<
  React.PropsWithChildren<{ slug: RadarSlug }>
> = ({ slug, children }) => (
  <RadarContext.Provider value={{ slug, descriptor: RADARS[slug] }}>
    {children}
  </RadarContext.Provider>
);

export const useRadar = () => useContext(RadarContext);
